import {css} from '@logistics-frontend/blocks/theme/css'
import {theme} from '@logistics-frontend/blocks/theme/theme'

import {Variant} from './types'

const variant: Record<`variant_${Variant}`, string> = {
  variant_postcard: css`
    ${theme.breakpoints.down('sm')} {
      display: none;
    }
  `,
}

export const classes = {
  root: css`
    justify-content: space-between;
    position: fixed;
    top: ${theme.spacing(2)}px;
    right: ${theme.spacing(2)}px;
    left: ${theme.spacing(2)}px;
    width: auto;
    padding: ${theme.spacing(1)}px;
    background-color: ${theme.go.schemes.colors.system.BgMain};
    box-shadow: 0 8px 20px rgba(117, 115, 111, 0.2);
    border-radius: 24px;
    min-height: 56px;

    [dir='rtl'] & {
      padding-right: ${theme.spacing(2)}px;
    }

    [dir='ltr'] & {
      padding-left: ${theme.spacing(2)}px;
    }

    ${theme.breakpoints.down('sm')} {
      padding: 0;
      min-height: auto;
      justify-content: center;
      background-color: transparent;
      box-shadow: none;

      [dir='rtl'] & {
        padding-right: 0;
      }

      [dir='ltr'] & {
        padding-left: 0;
      }
    }
  `,
  button: css`
    ${theme.breakpoints.down('sm')} {
      display: none !important;
    }
  `,
  ...variant,
}

export const additionalClasses = {
  isYandexIntegration: css`
    ${theme.breakpoints.up('sm')} {
      .${classes.root}& {
        right: unset;
        background-color: transparent;
        box-shadow: unset;
      }
    }
  `,
}
